import { postSendMailApi } from "../../http/api/MailAPI";

const sendMailPropsToInfo = (sendMailprops) => {

  let {mailFrom, mailToList, subject, text, attachedFileInfoList} = sendMailprops;
  
  return {
    "mailFrom" : mailFrom,
    "mailToList" : mailToList,
    "subject" : subject,
    "html" : `<div>${text.replaceAll("\n", "<br />")}</div>`,
    "attachedFileInfoList" : attachedFileInfoList
  }
}

export const sendMail = async (sendMailPropsList) => {

  try {
    console.log(sendMailPropsList.map(sendMailPropsToInfo))
    await postSendMailApi({mailSendInfoList: sendMailPropsList.map(sendMailPropsToInfo)});

  } catch (err) {
    console.log("Error", err);
    throw(err)
  }
};